/* eslint-disable dot-notation */
/* eslint-disable no-useless-computed-key */
import React, { useEffect, useState } from 'react';
import './style.scss';

const Roles = (props) => {
  const {
    match: {
      params: {
        id: selectedRoleId,
      },
    },
    roles,
    selectedRole,
    setSelectedRole,
  } = props;

  const [position, setPosition] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [clickedState, setClickedState] = useState('');
  const [searchedState, setSearchedState] = useState('');
  const [currentPosition, setCurrentPosition] = useState('');
  const [pressed, setPressed] = useState('');

  // eslint-disable-next-line global-require
  const resetIcon = require('../../assets/icons/reset-icon.jpeg');

  // to get the final_output from linking
  const url = window.location.href;
  const urlPositions = url.split('%20');
  const linkedPosition = urlPositions[urlPositions.length - 1];

  // higher order function for event callback handlers
  const parseInput = callback => e => callback(e.target.value) || setErrorMessage('');

  // eslint-disable-next-line consistent-return
  const onRoleSubmit = () => {
    if (position.length === 0) return setErrorMessage('No role provided');
    else setSelectedRole(position);
  };

  const handleClickEnter = e => e.keyCode === 13 && onRoleSubmit();

  useEffect(() => {
    if (selectedRoleId) {
      setSelectedRole(selectedRoleId);
    }
  }, [roles, selectedRoleId]);

  useEffect(() => {
    if (selectedRole) {
      console.log(selectedRole);
      // TODO: scroll to this role or highlight it in some way
    }
  }, [selectedRole]);

  function NoRoleClicked(role) {
    return (
      <div className="not-clicked">
        <div className="text-container">
          <h3>{role.title}</h3>
        </div>
      </div>
    );
  }

  function NoRoleClickedSearched(role) {
    return (
      <div className="not-clicked-searched">
        <div className="text-container">
          <h3>{role.title}</h3>
          <p>{role.description}</p>
        </div>
      </div>
    );
  }

  function RoleClicked(role) {
    return (
      <div className="clicked">
        <div className="text-container">
          <h3>{role.title}</h3>
          <p>{role.description}</p>
        </div>
      </div>
    );
  }

  function RoleClickedSearched(role) {
    return (
      <div className="clicked-and-searched">
        <div className="text-container">
          <h3>{role.title}</h3>
          <p>{role.description}</p>
        </div>
      </div>
    );
  }

  function SearchedState(role) {
    return (
      <div>
        {clickedState[role.title]
          ? RoleClickedSearched(role)
          : NoRoleClickedSearched(role)
        }
      </div>
    );
  }

  function NoSearchedState(role) {
    return (
      <div>
        {clickedState[role.title]
          ? RoleClicked(role)
          : NoRoleClicked(role)
          }
      </div>
    );
  }

  function reset() {
    setCurrentPosition('');
    setPressed(true);
  }


  function clickedButton(title) {
    // eslint-disable-next-line max-len
    const titles = ['Mayor/City Manager', 'Judge', 'District Attorney', 'Public Defender', 'County Sheriff', 'School Board Member', 'County Executive/Commisioner', 'City Council Member', 'State Senator', 'State Assembly/Representative', 'Governor', 'Lieutenant Governor'];
    let index, pos;
    if (title.length === 0) return;
    for (index = 0; index < titles.length; index += 1) {
      if (titles[index].toLowerCase().includes(title.toLowerCase())) {
        pos = titles[index];
        break;
      }
    }
    setCurrentPosition('');
    setPressed(true);
    setSearchedState({ ...searchedState, [pos]: true });
    // eslint-disable-next-line prefer-template
    const newPos = currentPosition + ' ' + pos;
    setCurrentPosition(newPos);
  }

  function deepLinked(title) {
    if (title.includes(linkedPosition)) {
      return true;
    } else if (title.includes('Senator') && linkedPosition.includes('Congress')) {
      return true;
    } else return false;
  }


  return (
    <div className="background">
      <div className="header">
        <p>
          Local elections play a critical role in the lives of every American.
          Learn about the roles and responsibilites that are elected during most local elections.
          Search for one below.
        </p>
        <p>{pressed}</p>
      </div>
      <div id="cta-box-container">
        <div id="cta-box-container-content">
          <div className="input-parent-container">
            <h2>Search For a Role</h2>
            <div className="input-container">
              <input
                className={errorMessage ? 'error-state' : ''}
                onChange={parseInput(setPosition)}
                onKeyDown={handleClickEnter}
                placeholder="Enter a title or responsibility"
                value={position}
              />
              {errorMessage && <p id="error-message">Error: {errorMessage}</p>}
              <button type="submit"
                onClick={() => (clickedButton(position))
                }
              >Find
              </button>
              <div className="link-image-container">
                <img className="link-image"
                  onClick={() => (reset())}
                  id="reset-icon"
                  src={resetIcon}
                  alt="Reset icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {roles.map(role => (
        <div className="hidden-role-container" onClick={() => (clickedButton(role.title))}>
          {(searchedState[role.title] && currentPosition.includes(role.title)) || (deepLinked(role.title) && !pressed)
            ? SearchedState(role)
            : NoSearchedState(role)}
        </div>
      ))}

      <div className="separator-line" />
      <div className="browse-container">
        <div className="browse-header">
          <p>
            Or Browse Through All The Roles We Have
          </p>
        </div>
        {roles.map(role => (
          <div className="role-container" onClick={() => (setClickedState({ ...clickedState, [role.title]: !clickedState[role.title] }))}>
            {clickedState[role.title]
              ? RoleClicked(role)
              : NoRoleClicked(role)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Roles;
